import { useTranslate } from "@refinedev/core";

/**
 * Wat een overzicht met dieren in een pleeggezin doet: weglaten, meenemen of alleen díe tonen.
 *
 * <p>Dit was een schuifje met twee standen -- aan of uit -- en daarmee kon je wel alles zien, maar niet
 * alléén de pleeggezinnen. Dat is juist de vraag die je stelt als je de pleegzorg nabelt: welke dieren
 * zitten er nu uit, en hoe staat het ermee. Drie standen dus, in dezelfde vorm als de andere keuzes in
 * deze overzichten.
 *
 * <p>Het aantal blijft erachter staan. Dat telt de dieren in een pleeggezin die door de overige filters
 * komen, dus het verandert mee met de zoekterm en de datums -- zonder dat getal is "Alleen
 * pleeggezinnen" een knop waarvan je pas na het klikken weet of er iets achter zit.
 */
export type PleegKeus = "geen" | "beide" | "alleen";

export const PLEEG_KEUZES: PleegKeus[] = ["geen", "beide", "alleen"];

export function PleegKeuze({
  waarde,
  aantal,
  onKies,
}: {
  waarde: PleegKeus;
  /** Hoeveel dieren in een pleeggezin door de overige filters komen. */
  aantal: number;
  onKies: (keus: PleegKeus) => void;
}) {
  const t = useTranslate();
  return (
    <div className="fawkes-pleegkeuze">
      <span className="fawkes-pleegkeuze__label">{t("pleeg.titel")}</span>
      <div
        className="fawkes-pleegkeuze__keuzes"
        role="group"
        aria-label={t("pleeg.titel")}
      >
        {PLEEG_KEUZES.map((k) => (
          <button
            key={k}
            type="button"
            className={waarde === k ? "is-active" : undefined}
            aria-pressed={waarde === k}
            data-testid={`pleeg-${k}`}
            onClick={() => onKies(k)}
          >
            {t(`pleeg.${k}`)}
          </button>
        ))}
      </div>
      <small className="fawkes-pleegkeuze__aantal">
        {aantal === 1 ? t("pleeg.aantalEen") : t("pleeg.aantal", { args: [aantal] })}
      </small>
    </div>
  );
}
